<h2 mat-dialog-title class="text-center">Holding Detail</h2>

<div mat-dialog-content>
  @if (holdDetails) {
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      @if (holdDetails?.tabHeaders[0]) {
        <mat-tab [label]="$safeNavigationMigration(holdDetails?.tabHeaders[0])" class="tab0">
          <div>
            <table>
              @for (item of holdDetails?.libraryInfo; track item) {
                <tr class="spaceUnder">
                  <td>{{ item?.label }}</td>
                  @if (typeOf($safeNavigationMigration(item?.value)) === 'string') {
                    <td class="str">{{ item?.value }}</td>
                  }
                  @if (typeOf($safeNavigationMigration(item?.value)) === 'object') {
                    <td class="obj">
                      <!-- <pre>{{item | json}}</pre>
                      <pre>address 1: - {{item.value.address1 | json}}</pre> -->
                      @if (item?.fieldId === 'Address') {
                        <span>
                          @if (item.value?.address1 && item.value?.address1 !== '') {
                            <div>Address 1: {{ item.value?.address1 }}</div>
                          }
                          @if (item.value?.address2 && item.value?.address2 !== '') {
                            <div>Address 2: {{ item.value?.address2 }}</div>
                          }
                          @if (item.value?.city && item.value?.city !== '') {
                            <div>City: {{ item.value?.city }}</div>
                          }
                          @if (item.value?.state && item.value?.state !== '') {
                            <div>State: {{ item.value?.state }}</div>
                          }
                          @if (item.value?.zipCode && item.value?.zipCode !== '') {
                            <div>Zip Code: {{ item.value?.zipCode }}</div>
                          }
                        </span>
                      }
                      @if (item?.fieldId === 'ShipToAddress') {
                        <span>
                          @if (item.value?.name && item.value?.name !== '') {
                            <div>Name: {{ item.value?.name }}</div>
                          }
                          @if (item.value?.address1 && item.value?.address1 !== '') {
                            <div>Address 1: {{ item.value?.address1 }}</div>
                          }
                          @if (item.value?.address2 && item.value?.address2 !== '') {
                            <div>Address 2:{{ item.value?.address2 }}</div>
                          }
                          @if (item.value?.city && item.value?.city !== '') {
                            <div>City:{{ item.value?.city }}</div>
                          }
                          @if (item.value?.state && item.value?.state !== '') {
                            <div>State:{{ item.value?.state }}</div>
                          }
                          @if (item.value?.zipCode && item.value?.zipCode !== '') {
                            <div>Zip Code:{{ item.value?.zipCode }}</div>
                          }
                        </span>
                      }
                    </td>
                  }
                  @if (typeOf($safeNavigationMigration(item?.value)) === 'array') {
                    <td class="array">
                      @if (item?.fieldId === 'HolidayList') {
                        <span>
                          @for (x of item?.value; track x) {
                            <div>
                              @if (
                                x?.startDate && x.startDate !== '' && x.endDate && x.endDate !== ''
                              ) {
                                <span>
                                  <div>Start Date: {{ x?.startDate }}</div>
                                  <div>End Date: {{ x?.endDate }}</div>
                                </span>
                              }
                              <br />
                            </div>
                          }
                        </span>
                      }
                    </td>
                  }
                </tr>
              }
            </table>
          </div>
        </mat-tab>
      }
      @if (holdDetails?.tabHeaders[1]) {
        <mat-tab [label]="$safeNavigationMigration(holdDetails?.tabHeaders[1])" class="tab1">
          <table>
            <thead>
              <tr>
                @for (item of holdDetails.shipping.headers; track item) {
                  <td>
                    @if (item !== '' && item !== null) {
                      <span>{{ item }}</span>
                    }
                    @if (item === '' || item === null) {
                      <span>&nbsp;</span>
                    }
                  </td>
                }
              </tr>
            </thead>
            <tbody>
              @for (item of holdDetails.shipping.items; track item) {
                <tr class="spaceUnder">
                  @if ($safeNavigationMigration(item?.shippingMethod) !== null) {
                    <td>{{ item?.shippingMethod }}</td>
                  }
                  @if ($safeNavigationMigration(item?.shippingMethod) === null) {
                    <td>&nbsp;</td>
                  }
                  @if ($safeNavigationMigration(item?.materials) !== null) {
                    <td>{{ item?.materials }}</td>
                  }
                  @if ($safeNavigationMigration(item?.materials) === null) {
                    <td>&nbsp;</td>
                  }
                  @if ($safeNavigationMigration(item?.willShip) !== null) {
                    <td>{{ item?.willShip }}</td>
                  }
                  @if ($safeNavigationMigration(item?.willShip) === null) {
                    <td>&nbsp;</td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </mat-tab>
      }
      @if (holdDetails?.tabHeaders[2]) {
        <mat-tab [label]="$safeNavigationMigration(holdDetails?.tabHeaders[2])" class="tab2">
          <table>
            <thead>
              <tr>
                @for (item of holdDetails.illAcceptance.headers; track item) {
                  <td>
                    @if (item !== '' && item !== null) {
                      <span>{{ item }}</span>
                    }
                    @if (item === '' || item === null) {
                      <span>&nbsp;</span>
                    }
                  </td>
                }
              </tr>
            </thead>
            <tbody>
              @for (item of holdDetails.illAcceptance.items; track item) {
                <tr class="spaceUnder">
                  @if ($safeNavigationMigration(item?.illAcceptanceMethods) !== null) {
                    <td>{{ item?.illAcceptanceMethods }}</td>
                  }
                  @if ($safeNavigationMigration(item?.illAcceptanceMethods) === null) {
                    <td>&nbsp;</td>
                  }
                  @if ($safeNavigationMigration(item?.illAcceptILLBy) !== null) {
                    <td>{{ item?.illAcceptILLBy }}</td>
                  }
                  @if ($safeNavigationMigration(item?.illAcceptILLBy) === null) {
                    <td>&nbsp;</td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </mat-tab>
      }
      @if (holdDetails?.tabHeaders[3]) {
        <mat-tab [label]="$safeNavigationMigration(holdDetails?.tabHeaders[3])">
          <table>
            <thead>
              <tr>
                @for (item of holdDetails.copies.headers; track item) {
                  <td>
                    @if (item !== '' && item !== null) {
                      <span>{{ item }}</span>
                    }
                    @if (item === '' || item === null) {
                      <span>&nbsp;</span>
                    }
                  </td>
                }
              </tr>
            </thead>
            <tbody>
              @for (item of holdDetails.copies.items; track item) {
                <tr class="spaceUnder">
                  @if ($safeNavigationMigration(item?.copyies) !== null) {
                    <td>{{ item?.copyies }}</td>
                  }
                  @if ($safeNavigationMigration(item?.copyies) === null) {
                    <td>&nbsp;</td>
                  }
                  @if ($safeNavigationMigration(item?.photoCopy) !== null) {
                    <td>{{ item?.photoCopy }}</td>
                  }
                  @if ($safeNavigationMigration(item?.photoCopy) === null) {
                    <td>&nbsp;</td>
                  }
                  @if ($safeNavigationMigration(item?.fax) !== null) {
                    <td>{{ item?.fax }}</td>
                  }
                  @if ($safeNavigationMigration(item?.fax) === null) {
                    <td>&nbsp;</td>
                  }
                  @if ($safeNavigationMigration(item?.arielEmailOther) !== null) {
                    <td>{{ item?.arielEmailOther }}</td>
                  }
                  @if ($safeNavigationMigration(item?.arielEmailOther) === null) {
                    <td>&nbsp;</td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </mat-tab>
      }
    </mat-tab-group>
  }
</div>
<div mat-dialog-actions align="end">
  <button
    role="button"
    type="button"
    aria-label="Close"
    mat-button
    cdkFocusInitial
    (click)="dialogRef.close()"
  >
    Close
  </button>
</div>
